import React from 'react';
import TextField from 'shared/components/text-field/TextField';
import SelectDropdown from 'shared/components/select-dropdown/SelectDropdown';

class SeriesStaticForm extends React.Component {
  constructor(props){
    super(props);
    this.exercies = [...Array(10).keys()].map(value => {
      return { value: value + 1, option: value + 1 };
    });

    this.reps = [
      {value: 'Custom Rep', option: 'Custom Rep'},
      {value: 'Method', option: 'Method'}
    ];

    this.sets = [...Array(100).keys()].map(value => {
      return { value: value + 1, option: value + 1 };
    });
  }

  handleExerciseNumChange = (name, exerciesNumValue)=> {
    exerciesNumValue = ~~exerciesNumValue;
    let { values, setFieldValue, editMood } = this.props;
    let exercisesListLength = values.ExerciesList.length;
    if(exerciesNumValue !== exercisesListLength){
      if(editMood && exerciesNumValue < exercisesListLength){
        let deletedExercies = [];
        let i = 0;
        for (i = exerciesNumValue; i < exercisesListLength; i++){
          if(values.ExerciesList[i] && values.ExerciesList[i].id) {
            deletedExercies.push(values.ExerciesList[i].id);
          }
        }
        setFieldValue('deletedExercies', [...deletedExercies, ...(values.deletedExercies || [])]);
      }

      let newExercisesList = [];
      [...Array(~~exerciesNumValue).keys()].forEach(index => {
        newExercisesList.push(index < exercisesListLength ? values.ExerciesList[index] : null);
      });
      setFieldValue('ExerciesList', newExercisesList);
    }
  }

  render() {
  let { exerciseNumField, repsTypeField, uniquenessError } = this.props;
    return (
      <div className="form-content">
        <TextField
          type="text"
          name="seriesName"
          label="Series Name"
          placeholder="e.g. “Series A”"
          error={uniquenessError}
        />
        <SelectDropdown
          name={exerciseNumField}
          options={this.exercies}
          label="NO. Exercises"
          handleChange={this.handleExerciseNumChange}
        />
        <SelectDropdown name={repsTypeField} options={this.reps} label="REPS" />
        <SelectDropdown name="sets" options={this.sets} label="Sets" />
      </div>
    );
  }
}

export default SeriesStaticForm;
